export default "__VITE_ASSET__DO$E9jpN__"